<template>
<div >
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
            <!-- <el-tab-pane label="柱状图" name="first" :key="'first'" >
                <child1 v-if="firstisRouterAlive" ></child1>                    
            </el-tab-pane>   
            <el-tab-pane label="图" name="second" :key="'second'"  >
                <child2 v-if="secondisRouterAlive" ></child2>             
            </el-tab-pane> -->
             <!-- <el-tab-pane label="短信使用统计" name="Three" :key="'Three'"  >
                <child3 v-if="threeisRouterAlive" ></child3>   
             
            </el-tab-pane> -->
             <el-tab-pane label="充值明细" name="Four" :key="'Four'"  v-if="TenancyId=='0'||TenancyId==null">
                <child4 v-if="fourisRouterAlive" ></child4>   
         
            </el-tab-pane>
            <el-tab-pane label="短信统计日视图" name="second" :key="'second'" v-if="TenancyId=='0'||TenancyId==null" >
                <child2 v-if="secondisRouterAlive" ></child2>             
            </el-tab-pane>
            <el-tab-pane label="短信统计月视图" name="first" :key="'first'" v-if="TenancyId=='0'||TenancyId==null" >
                <child1 v-if="firstisRouterAlive" ></child1>             
            </el-tab-pane>     
            <el-tab-pane label="业务办理统计" name="five" :key="'five'"  >
                <child5 v-if="fiveRouterAlive" ></child5>             
            </el-tab-pane>   
            <el-tab-pane label="业务消费统计" name="Six" :key="'Six'"   >
                <child6 v-if="sixRouterAlive" ></child6>             
            </el-tab-pane>   
             <el-tab-pane label="时间流量统计" name="seven" :key="'seven'"   >
                <child7 v-if="sevenRouterAlive" ></child7>             
            </el-tab-pane> 
              <el-tab-pane label="客户类型统计" name="eight" :key="'eight'"    >
                <child8 v-if="eightRouterAlive" ></child8>             
            </el-tab-pane>                         
        </el-tabs>
       
    </div>



</template>

<script>
// import MemberList from '@/views/MemberManagement/MemberList.vue'
// import WeChatMember from '@/views/MemberManagement/WeChatMember.vue'
// import chartBar from '@/views/MemberManagement/chart/chartBar.vue'
// import chartColumn from '@/views/MemberManagement/chart/chartColumn.vue'
import chartLine from '@/views/MemberManagement/chart/chartLine.vue'
// import chartPie from '@/views/MemberManagement/chart/chartPie.vue'
import ShopRechargeLog from '@/views/ShopManagement/ShopRechargeLog.vue'
import ShopEventLog from '@/views/ShopManagement/ShopEventLog.vue'
import MonthShopEventLog from '@/views/ShopManagement/MonthShopEventLog.vue'
import BuesinessStatistics from '@/views/ShopManagement/BuesinessStatistics.vue'
import BuesinessConsumption from '@/views/ShopManagement/BuesinessConsumption.vue'
import BuesinessFlow from '@/views/ShopManagement/BuesinessFlow.vue'
import CustomerType from '@/views/ShopManagement/CustomerType.vue'


import {mapGetters} from 'vuex';
// const zcfzCont = resolve =>require(['@/views/MemberManagement/chart/chartBar.vue'], resolve)
// import tabZujianChild2 from '@/tabComponents/tabZujianChild2'
  export default {
     name: 'tabZujian',
    components:{
        child1:MonthShopEventLog,
        child2:ShopEventLog,
        child3:chartLine,
        child4:ShopRechargeLog,
        child5:BuesinessStatistics,
        child6:BuesinessConsumption,
        child7:BuesinessFlow,
        child8:CustomerType
        // child2:this.$nextTick(() => { this.EChart= resolve => require([chartBar],resolve)}
        // child2:resolve => {require(['@/views/MemberManagement/chart/chartBar.vue'], resolve)},
    },
    data() {
      return {
          TenancyId:'',
        activeName2: 'Three',
        // 刷新子组件
        firstisRouterAlive: true,
       secondisRouterAlive:true,
       threeisRouterAlive:true,
       fourisRouterAlive:true,
       fiveRouterAlive:true,
       sixRouterAlive:true,
       sevenRouterAlive:true,
       eightRouterAlive:true
      };
      
    },
    methods: {
      ...mapGetters(['getuserstate']),
      handleClick(tab, event) {
      
      //刷新组件解决样式style值丢失问题
       this.reload(tab);
      },
       reload (tab) {
          if(tab.name=='first')
        {
          // console.log(tab.name);
         this.firstisRouterAlive = false
        this.$nextTick(() => (this.firstisRouterAlive = true))

        }
        if(tab.name=='second')
        {
          // console.log(tab.name);
         this.secondisRouterAlive = false
        this.$nextTick(() => (this.secondisRouterAlive = true))

        }
        if(tab.name=='Three')
        {
        this.threeisRouterAlive = false
        this.$nextTick(() => (this.threeisRouterAlive = true))

        }
         if(tab.name=='Four')
        {
        this.fourisRouterAlive = false
        this.$nextTick(() => (this.fourisRouterAlive = true))

        }
    //  this.isRouterAlive = false
    //  this.$nextTick(() => (this.isRouterAlive = true))
   }   
    },
    mounted() {
    				 this.TenancyId=JSON.parse(this.getuserstate()).TenancyId;
		}


  };
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// SummaryTabsView.vue?f12fb4ee